var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c(
        "CabeceraModal",
        {
          attrs: { titulo: "Crear Producto" },
          on: { cerrar: _vm.handleCerrar }
        },
        [
          _c("div", {
            staticStyle: {
              "letter-spacing": "0.02em",
              "white-space": "nowrap",
              overflow: "hidden",
              "text-overflow": "ellipsis",
              "margin-top": "16px"
            }
          }),
          _c(
            "div",
            { staticClass: "boton_crear" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "icon",
                  staticStyle: {
                    "background-color": "rgb(255, 108, 0)",
                    "border-color": "rgb(255, 108, 0)",
                    "padding-right": "20px",
                    display: "block",
                    margin: "0 0 0 auto",
                    "margin-top": "13px",
                    height: "38px"
                  },
                  on: { click: _vm.editar }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "color-blanco",
                      staticStyle: { color: "white" }
                    },
                    [_vm._v("Guardar")]
                  )
                ]
              )
            ],
            1
          )
        ]
      ),
      _c("CrudStepsNavBar", {
        attrs: { pasos: _vm.pasos, "validar-paso": false },
        model: {
          value: _vm.pasoActivoIndex,
          callback: function($$v) {
            _vm.pasoActivoIndex = $$v
          },
          expression: "pasoActivoIndex"
        }
      }),
      _c("ContenidoModal", [
        _c(
          "div",
          { attrs: { align: "center" } },
          [
            _c(
              "v-flex",
              { attrs: { md10: "" } },
              [
                _c(
                  "v-card",
                  { staticClass: "rounded-card" },
                  [
                    _c(
                      "v-form",
                      {
                        ref: "form",
                        staticClass: "col-md-12",
                        attrs: { "lazy-validation": "" }
                      },
                      [
                        _c(
                          "v-container",
                          {
                            staticStyle: { padding: "30px 40px 50px 40px" },
                            attrs: { "grid-list-md": "" }
                          },
                          [
                            _c(
                              "FormFieldsContainer",
                              { attrs: { titulo: "Crear Producto" } },
                              [
                                _vm._t("prependInformacionGeneral"),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label:
                                          _vm.formFields.codigoProducto.label,
                                        disabled: "",
                                        required: ""
                                      },
                                      model: {
                                        value:
                                          _vm.formFields.codigoProducto.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.codigoProducto,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.codigoProducto.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "numeric",
                                          expression: "'numeric'"
                                        }
                                      ],
                                      attrs: {
                                        label:
                                          _vm.formFields.codigoProductoP.label,
                                        "error-messages": _vm.errors.collect(
                                          "telefonoFijo2"
                                        ),
                                        "data-vv-name": "telefonoFijo2",
                                        type: "text",
                                        required: ""
                                      },
                                      model: {
                                        value:
                                          _vm.formFields.codigoProductoP.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.codigoProductoP,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.codigoProductoP.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "numeric",
                                          expression: "'numeric'"
                                        }
                                      ],
                                      attrs: {
                                        label: _vm.formFields.codigoInet.label,
                                        "error-messages": _vm.errors.collect(
                                          "telefonoFijo"
                                        ),
                                        "data-vv-name": "telefonoFijo",
                                        type: "text",
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.formFields.codigoInet.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.codigoInet,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.codigoInet.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "max:50",
                                          expression: "'max:50'"
                                        }
                                      ],
                                      attrs: {
                                        label: _vm.formFields.nombrecrm.label,
                                        "error-messages": _vm.errors.collect(
                                          "name"
                                        ),
                                        "data-vv-name": "name",
                                        counter: 50,
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.formFields.nombrecrm.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.nombrecrm,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.nombrecrm.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "max:50",
                                          expression: "'max:50'"
                                        }
                                      ],
                                      attrs: {
                                        label:
                                          _vm.formFields.descripcionCorta.label,
                                        "error-messages": _vm.errors.collect(
                                          "name"
                                        ),
                                        "data-vv-name": "name",
                                        counter: 50,
                                        required: ""
                                      },
                                      model: {
                                        value:
                                          _vm.formFields.descripcionCorta.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.descripcionCorta,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.descripcionCorta.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label:
                                          _vm.formFields.descripcionLarga.label,
                                        required: ""
                                      },
                                      model: {
                                        value:
                                          _vm.formFields.descripcionLarga.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.descripcionLarga,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.descripcionLarga.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "numeric",
                                          expression: "'numeric'"
                                        }
                                      ],
                                      attrs: {
                                        label:
                                          _vm.formFields.cuentaIngreso.label,
                                        "error-messages": _vm.errors.collect(
                                          "telefonoFijo3"
                                        ),
                                        "data-vv-name": "telefonoFijo3",
                                        type: "text"
                                      },
                                      model: {
                                        value:
                                          _vm.formFields.cuentaIngreso.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.cuentaIngreso,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.cuentaIngreso.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "numeric",
                                          expression: "'numeric'"
                                        }
                                      ],
                                      attrs: {
                                        label: _vm.formFields.cuentaCosto.label,
                                        "error-messages": _vm.errors.collect(
                                          "telefonoFijo4"
                                        ),
                                        "data-vv-name": "telefonoFijo4",
                                        type: "text"
                                      },
                                      model: {
                                        value: _vm.formFields.cuentaCosto.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.cuentaCosto,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.cuentaCosto.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { sm4: "", md4: "" } },
                                  [
                                    _c("v-autocomplete", {
                                      attrs: {
                                        label: _vm.formFields.plataforma.label,
                                        items: _vm.plataformaList,
                                        "item-text": "producto",
                                        "item-value": "configid_producto",
                                        clearable: "",
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.formFields.plataforma.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.plataforma,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.plataforma.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { sm4: "", md4: "" } },
                                  [
                                    _c("v-autocomplete", {
                                      attrs: {
                                        label: _vm.formFields.producto.label,
                                        items: _vm.porductoList,
                                        "item-text": "configvalor_clase",
                                        "item-value": "configid_clase",
                                        clearable: "",
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.formFields.producto.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.producto,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.producto.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { sm4: "", md4: "" } },
                                  [
                                    _c("v-autocomplete", {
                                      attrs: {
                                        label: _vm.formFields.tipoequipo.label,
                                        items: _vm.tipoEquipoList,
                                        "item-text": "tipoeqname",
                                        "item-value": "tipoeqid",
                                        clearable: "",
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.formFields.tipoequipo.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.tipoequipo,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.tipoequipo.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: _vm.formFields.estado.label,
                                        disabled: "",
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.formFields.estado.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.estado,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.estado.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-autocomplete", {
                                      attrs: {
                                        label:
                                          _vm.formFields.visible_cotizador
                                            .label,
                                        items: [
                                          { id: "true", name: "SI" },
                                          { id: "false", name: "NO" }
                                        ],
                                        "item-text": "name",
                                        "item-value": "id",
                                        required: ""
                                      },
                                      model: {
                                        value:
                                          _vm.formFields.visible_cotizador
                                            .value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.visible_cotizador,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.visible_cotizador.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-switch", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "`required`"
                                        }
                                      ],
                                      attrs: {
                                        label: _vm.activaArriendo
                                          ? "Activar"
                                          : "Desactivar",
                                        id: "activa_arriendo",
                                        color: "green",
                                        hint:
                                          "Al activar esta opción se encontrara disponible para arrendar este producto",
                                        "persistent-hint": true
                                      },
                                      model: {
                                        value: _vm.activaArriendo,
                                        callback: function($$v) {
                                          _vm.activaArriendo = $$v
                                        },
                                        expression: "activaArriendo"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }